// extracted by mini-css-extract-plugin
export default {"currentTimeIndicator":"UcdNHUyo","circularPart":"SyfCsnot","linePart":"mQkfQLvX"};